import { useEffect, useState } from 'react';
import { apiJson } from '../api/client';
import { useAuth } from '../state/AuthProvider';
import { Shell } from '../ui/PwaContent';

type AdminUser = {
  id: number;
  username: string;
  real_name: string;
  email: string;
  is_active: number;
  is_admin: number;
};

export function AdminView() {
  const authContext = useAuth();
  const [users, setUsers] = useState<AdminUser[]>([]);
  const [message, setMessage] = useState('');

  async function loadUsers() {
    const response = await apiJson<{ users: AdminUser[] }>(authContext.apiBaseUrl, '/admin/users');
    setUsers(response.users);
  }

  async function setActive(userId: number, active: boolean) {
    await apiJson(authContext.apiBaseUrl, `/admin/users/${userId}/${active ? 'activate' : 'deactivate'}`, { method: 'POST' });
    setMessage(active ? 'Benutzer aktiviert.' : 'Benutzer deaktiviert.');
    await loadUsers();
  }

  useEffect(() => {
    void loadUsers().catch((error) => setMessage(error instanceof Error ? error.message : 'Benutzer konnten nicht geladen werden.'));
  }, []);

  return (
    <Shell title="Admin" subtitle="Benutzer aktivieren und verwalten.">
      {message && <div className="mb-4 rounded-xl bg-gray-100 p-3 text-sm">{message}</div>}

      <div className="overflow-auto">
        <table className="w-full border-collapse text-left text-sm">
          <thead>
            <tr className="border-b">
              <th className="p-2">Name</th>
              <th className="p-2">Login</th>
              <th className="p-2">Status</th>
              <th className="p-2">Aktion</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} className="border-b">
                <td className="p-2"><strong>{user.real_name}</strong><br /><span className="text-gray-500">{user.email}</span></td>
                <td className="p-2">{user.username}</td>
                <td className="p-2">{Number(user.is_active) === 1 ? 'aktiv' : 'wartet'}</td>
                <td className="p-2">
                  {Number(user.is_active) === 1 ? (
                    <button className="wwpwa-button-secondary" onClick={() => void setActive(user.id, false)}>Deaktivieren</button>
                  ) : (
                    <button className="wwpwa-button-primary" onClick={() => void setActive(user.id, true)}>Aktivieren</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Shell>
  );
}
